var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import colors from '../colors';
var uncheckedDisabled = {
    '.Mui-disabled + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: colors.white,
        border: '1px solid ' + colors.grey[300],
    },
    '.Mui-disabled .MuiSwitch-thumb': {
        opacity: 1,
        backgroundColor: colors.white,
        border: '1px solid ' + colors.grey[300],
    },
};
var checkedDisabled = {
    '&.Mui-disabled + .MuiSwitch-track': {
        backgroundColor: colors.grey[300],
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
        border: '1px solid transparent',
        filter: 'grayscale(1) brightness(1.4)', // the color is built-in inside the icon, therefore we apply css filters.
    },
};
var checkedStyles = {
    '&.Mui-checked': __assign(__assign({ transform: 'translateX(14px)', color: colors.white, '& + .MuiSwitch-track': {
            backgroundColor: colors.blue[500],
            opacity: 1,
            border: 0,
        } }, checkedDisabled), { '& .MuiSwitch-thumb:before': {
            content: "''",
            color: colors.blue[500],
            position: 'absolute',
            width: '100%',
            height: '100%',
            left: 0,
            top: 0,
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"12\" viewBox=\"0 0 12 12\" width=\"12\"><path d=\"M0 0h12v12H0z\" fill=\"none\" /><path fill=\"".concat(encodeURIComponent(colors.blue[500]), "\" stroke=\"").concat(encodeURIComponent(colors.blue[500]), "\" stroke-width=\"\" stroke-linecap=\"round\" d=\"M4.5 8.1 2.4 6l-.7.7L4.5 9.5 10.5 3.5l-.7-.7L4.5 8.1z\"/></svg>')"),
        } }),
};
var uncheckedStyles = {
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: '16px',
        height: '16px',
        boxShadow: 'none',
        backgroundColor: colors.white,
    },
    '& .MuiSwitch-track': {
        borderRadius: '50px',
        backgroundColor: colors.grey[300],
        opacity: 1,
        boxShadow: 'none',
    },
};
export var MuiSwitch = {
    defaultProps: {
        disableRipple: true,
    },
    styleOverrides: {
        root: __assign(__assign(__assign({ width: 34, height: 20, padding: 0 }, uncheckedDisabled), uncheckedStyles), { '& .MuiSwitch-switchBase': __assign({ padding: 0, margin: 2, transitionDuration: '300ms' }, checkedStyles) }),
    },
};
